import { ref, watch, computed, reactive } from '@vue/composition-api'
import store from '@/store'
import { isAdmin, isManager } from "@/auth/utils";


export default function useUserEdit() {


  const form = reactive({
    name: '',
    email: '',
    expire_at: '',
    referenceKey: '',
    enabled: false,
    // manager_id: null,
    role: null,
    password: '',
    password_confirmation: '',
    avatar: '',
    commercialRecordNumber:'',
    identityNumber: '',
    commercialRecordIssueDateHijri:'',
    phoneNumber: '',
    emailAddress:'',
    managerName:'',
    managerPhoneNumber:'',
    managerMobileNumber:'',
    wasl:false,
    isManager:false,
    manager_id:0,

    cam_username:'',
    cam_password:'',

  })
  watch(form,()=>{
   
    if(form.isManager){

      delete  form.manager_id;
     // form.manager_id=0;


    }
   
  })

  const requestStatus = ref(false)
  const managersOptions = ref([])

  const statusOptions = [{ title: 'Active', value: 1 }, { title: 'Inactive', value: 0 }]

  const auth = store.getters['auth/user']

  store.dispatch('appUser/getManagers', { type: 'user', user: auth.id ,isManager:1})
     .then(res =>{
       managersOptions.value =  res.data.data  
            }
       ).catch(reason => {})


  return {
    form,
    requestStatus,
    managersOptions,
    statusOptions,
  }

}
